import { render, staticRenderFns } from "./QuizTeacherLeaderBoard.vue?vue&type=template&id=15fa1348&"
import script from "./QuizTeacherLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherLeaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherLeaderBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports